<template>
  <b-container>
    <b-row v-if="searching">
      <b-col>
        <search-influencer @close="init()" />
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col cols="10" class="p-0">
        <h4 class="font-weight-bold vip-content-total">
          Vello VIP Content
          <small v-if="list"> ({{ total }}) </small>
        </h4>
      </b-col>

      <b-col cols="2" class="search-trigger pr-0 pr-md-3">
        <b-icon-search class="cursor" @click="searching = true" />
      </b-col>

      <b-col cols="12" class="p-0 mb-2">
        <small>
          Some of our Vello personalities create premium video content for their
          fans. Select from the profiles below and subscribe to view their VIP
          content in the Vello app.
        </small>
        <p class="grey-dark vip-no-content" v-if="!list || list.length === 0">
          <small v-show="!loading"> No VIP influencers found </small>
        </p>
      </b-col>
    </b-row>

    <transition name="fade">
      <b-row v-if="list && list.length > 0" align-v="center">
        <b-col
          v-for="(influencer, index) in list"
          :key="index"
          class="overflow-hidden text-left gradient-border py-3 m-0"
          cols="12"
          md="6"
          lg="4"
        >
          <b-row
            :align-v="
              user.influencer_uid !== influencer.influencer_uid
                ? `center`
                : `start`
            "
          >
            <b-col
              cols="3"
              class="p-0 pl-3 pr-1 cursor"
              @click="
                $router.push(
                  '/influencer/' +
                    influencer.influencer_uid +
                    `/` +
                    influencer.username
                )
              "
            >
              <div
                class="rounded-circle"
                v-if="influencer"
                :style="
                  `background:url(` +
                  influencer.profile_photo_url +
                  `) center/cover;
                    padding: 50%`
                "
              />
            </b-col>

            <b-col cols="9" md="9">
              <b-row>
                <b-col cols="8" md="12">
                  <p
                    class="d-block font-weight-bold overflow-hidden m-0"
                    v-if="influencer.full_name"
                  >
                    <b-link
                      class="text-white"
                      :to="
                        `/influencer/` +
                        influencer.influencer_uid +
                        `/` +
                        influencer.username
                      "
                      v-text="influencer.full_name"
                    />
                  </p>
                  <small
                    class="grey-light d-block"
                    v-if="influencer"
                    v-text="`@` + influencer.username"
                  />
                </b-col>

                <b-col
                  cols="4"
                  md="12"
                  class="v-center mt-md-2"
                  v-if="influencer.influencer_uid !== user.influencer_uid"
                >
                  <b-button
                    size="sm"
                    variant="black"
                    class="rounded-pill float-left cursor"
                    v-if="influencer.is_following"
                    @click="unFollow(influencer)"
                  >
                    <small
                      class="v-center text-capitalize"
                      style="letter-spacing: 0.5px"
                    >
                      <small>following</small>
                    </small>
                  </b-button>
                  <b-button
                    size="sm"
                    variant="primary"
                    class="rounded-pill float-left px-3"
                    v-else
                    @click="follow(influencer)"
                  >
                    <small
                      class="v-center text-capitalize"
                      style="letter-spacing: 0.5px"
                    >
                      <small>follow</small>
                    </small>
                  </b-button>
                </b-col>
              </b-row>
              <confirmation-modal
                :id="influencer.influencer_uid"
                :ok-title="`Unfollow @` + influencer.username"
                :only-confirm="true"
                @is-confirmed="true ? confirmUnfollow(influencer) : ``"
              ></confirmation-modal>
            </b-col>
          </b-row>
        </b-col>

        <b-col v-if="has_more" class="text-center m-auto pt-4" cols="12">
          <a href="javascript:;" @click="loadInfluencers">
            <b-spinner v-if="loading" small class="mr-2" />
            <small>show more +</small>
          </a>
        </b-col>
      </b-row>
    </transition>
  </b-container>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions, mapMutations } from 'vuex'
import SearchInfluencer from '../../components/SearchInfluencer'
import ConfirmationModal from '@/views/components/ConfirmationModal'

export default {
  name: 'VipPage',
  components: {
    SearchInfluencer,
    ConfirmationModal,
  },

  data() {
    return {
      searching: false,
      keyword: '',
      showSearchButton: true,
      showSearch: false,
      showClear: false,
      loading: false,
      limit: 18,
      page: 1,
    }
  },

  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      list: (state) => state.influencer.list,
      total: (state) => state.influencer.total,
      has_more: (state) => state.influencer.has_more,
    }),

    params() {
      return {
        limit: this.limit,
        page: this.page,
        search: this.keyword,
      }
    },
  },

  methods: {
    ...mapActions({
      getVIP: 'influencer/getVIP',
    }),
    ...mapMutations({
      clearList: 'influencer/clearList',
    }),

    async loadInfluencers() {
      this.loading = true

      await this.getVIP(this.params)

      this.loading = false
      this.page++
    },

    async clearInfluencers() {
      await this.clearList()
    },

    clearKeyword() {
      this.keyword = ''
      this.searchFollowing()
    },

    closeSearch() {
      let vm = this

      vm.showSearch = false

      setTimeout(function () {
        vm.showSearchButton = true
      }, 300)
    },

    searchFollowing: _.debounce(function () {
      this.page = 1
      this.showClear = this.keyword !== ''

      this.clearInfluencers()
      this.loadInfluencers()
    }, 500),

    async follow(influencer) {
      influencer.is_following = true

      await this.$api.put(`influencer/${influencer.influencer_uid}/follow`)
    },

    async unFollow(influencer) {
      this.$bvModal.show(influencer.influencer_uid)
    },

    async confirmUnfollow(influencer) {
      await this.$api.delete(`influencer/${influencer.influencer_uid}/follow`)
      this.$bvModal.hide(influencer.influencer_uid)

      influencer.is_following = false
    },

    init() {
      this.page = 1
      this.searching = false
    },
  },

  async created() {
    this.init()
    this.loadInfluencers()
  },

  async destroyed() {
    await this.clearList()
  },
}
</script>

<style lang="scss" scoped></style>
